import { render, staticRenderFns } from "./dtcinputblock.vue?vue&type=template&id=58fbdfe2"
import script from "./dtcinputblock.vue?vue&type=script&lang=ts"
export * from "./dtcinputblock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports